<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <div class="dialog-container" [class.success-state]="signingState === 'success'">
      <!-- Success State -->
      @if (signingState === 'success') {
        <div class="success-content">
          <div class="success-icon-container">
            <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
          </div>
          <h2 class="success-title">{{ t('lang.waiver_signing_success') }}</h2>
          <p class="success-subtitle">{{ t('lang.waiver_signing_success_subtitle') }}</p>
        </div>
      } @else {
        <!-- Header -->
        <div class="dialog-header">
          <h2 class="dialog-title">{{ t('lang.waiver_dialog_title') }}</h2>
          <p class="dialog-subtitle">
            {{ t(waiverDialogSubtitleKey, { entity: integrationEntityName }) }}
          </p>
          <button class="close-button" (click)="onCancel()" type="button">
            <mzic-svg src="assets/icons/mzic-close.svg" />
          </button>
        </div>

        <!-- Content -->
        <div class="dialog-content">
          <!-- Loading Shimmer -->
          @if (loading) {
            <div class="waivers-shimmer">
              @for (i of shimmerItems; track i) {
                <div class="shimmer-waiver">
                  <div class="shimmer-icon"></div>
                  <div class="shimmer-content">
                    <div class="shimmer-title"></div>
                    <div class="shimmer-subtitle"></div>
                  </div>
                  <div class="shimmer-button"></div>
                </div>
              }
            </div>
          } @else {
            <!-- Waivers List -->
            <div class="waivers-list">
              @for (waiver of waivers; track waiver.id) {
                <button
                  class="waiver-card"
                  (click)="viewDocument(waiver)"
                  type="button">
                  <div class="waiver-card-content">
                    <span class="waiver-card-title">
                      {{ t('lang.' + getWaiverLabel(waiver)) }}
                    </span>
                    <span class="waiver-card-action">
                      {{ waiverViewDocumentLabel }}
                      <mzic-svg src="assets/icons/right-upward-arrow.svg" />
                    </span>
                  </div>
                </button>
              }
            </div>

            <!-- Acceptance Section -->
            <div class="acceptance-section">
              <label class="checkbox-container">
                <input
                  type="checkbox"
                  [checked]="isAccepted()"
                  (change)="toggleAcceptance()"
                  [disabled]="loading || signingState === 'submitting'" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">
                  {{ t('lang.waiver_acceptance_text') }}
                </span>
              </label>
            </div>
          }
        </div>

        <!-- Footer -->
        <div class="dialog-footer">
          <button
            class="primary-button"
            [disabled]="!canSign"
            (click)="onSign()"
            type="button">
            @if (signingState === 'submitting') {
              <mzic-spinner />
              {{ t('lang.waiver_sign_confirming') | uppercase }}
            } @else {
              {{ t('lang.waiver_sign_button') | uppercase }}
            }
          </button>
          <button
            class="secondary-button"
            [disabled]="signingState === 'submitting'"
            (click)="onBack()"
            type="button">
            {{ t('lang.back') | uppercase }}
          </button>
        </div>
      }
    </div>
  </div>

</ng-container>
